
export { BvlFormAutocompleteComponent as BvlFormAutocomplete } from './form-autocomplete.component';
export { BvlFormAutocompleteModule } from './form-autocomplete.module';
